/**
 * Возвращает объект выбранного периода размещения.
 *
 * @param {ISelectedTerm} объект выбранного типа размещения из placingTermsApi
 */
export const getCurrentPeriodFromSelected = (selected) => selected && selected.option && selected.option.selectedPeriod;
